import React from "react";

const Filter3LineIcon = () => (
	<g>
		<path d='M10 18H14V16H10V18ZM3 6V8H21V6H3ZM6 13H18V11H6V13Z' />
	</g>
);

export default Filter3LineIcon;
